import React, { useState } from "react";
import { waAnchorProps } from "../../../lib/whatsapp";
import { toast } from "sonner";
import { Loader2, Wand2, MessageCircle, Copy } from "lucide-react";
import { grApi } from "./grApi";

// WhatsApp composer: paste a guest question → KB-based draft → open WhatsApp with the text ready.
export function WhatsAppComposer() {
  const [question, setQuestion] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [draft, setDraft] = useState("");
  const [topic, setTopic] = useState("");
  const [busy, setBusy] = useState(false);

  const compose = async () => {
    if (!question.trim()) { toast.error("Incolla la domanda dell'ospite"); return; }
    setBusy(true);
    try { const r = await grApi.compose({ question, guest_name: name }); setDraft(r.draft || ""); setTopic(r.topic || ""); if ((r.confidence || 0) < 0.6) toast.message("Argomento non coperto: controlla bene la bozza"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Errore"); } finally { setBusy(false); }
  };
  const digits = phone.replace(/\D/g, "");
  const waProps = waAnchorProps(digits, draft);
  const copy = () => { navigator.clipboard?.writeText(draft); toast.success("Copiato"); };

  return (
    <div className="mt-4 max-w-2xl space-y-3" data-testid="wa-composer">
      <p className="text-xs text-[#7c5a4e]">Incolla qui la domanda ricevuta su WhatsApp: l'IA prepara la risposta con la stessa base di conoscenza delle e-mail. Correggi e apri WhatsApp con il testo già pronto.</p>
      <div className="grid sm:grid-cols-2 gap-2">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nome ospite (opzionale)" className="rounded-lg border border-[#e8dcc8] px-3 py-2 text-sm" data-testid="wa-name" />
        <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Numero WhatsApp (es. 333 1234567)" className="rounded-lg border border-[#e8dcc8] px-3 py-2 text-sm" data-testid="wa-phone" />
      </div>
      <textarea value={question} onChange={(e) => setQuestion(e.target.value)} rows={3} placeholder="Domanda dell'ospite…" className="w-full rounded-xl border border-[#e8dcc8] px-3 py-2 text-sm" data-testid="wa-question" />
      <button onClick={compose} disabled={busy} className="inline-flex items-center gap-1.5 rounded-full bg-[#4a1c17] hover:bg-[#2b1410] text-[#f7ebdf] px-4 py-2 text-sm font-semibold disabled:opacity-60" data-testid="wa-compose">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Wand2 className="h-4 w-4" />} Prepara risposta</button>
      {draft && (
        <div className="rounded-2xl border border-[#e8dcc8] bg-white p-3 space-y-2" data-testid="wa-result">
          {topic && <div className="text-[11px] uppercase tracking-wide font-semibold text-[#7c5a4e]">Argomento: {topic}</div>}
          <textarea value={draft} onChange={(e) => setDraft(e.target.value)} rows={5} className="w-full rounded-xl border border-[#e8dcc8] px-3 py-2 text-sm" data-testid="wa-draft" />
          <div className="flex flex-wrap gap-2 justify-end">
            <button onClick={copy} className="inline-flex items-center gap-1 rounded-full border border-[#e8dcc8] px-3 py-1.5 text-sm text-[#4a1c17] hover:bg-[#f7ebdf]" data-testid="wa-copy"><Copy className="h-4 w-4" /> Copia</button>
            <a {...waProps} className="inline-flex items-center gap-1.5 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-white px-4 py-1.5 text-sm font-bold" data-testid="wa-open"><MessageCircle className="h-4 w-4" /> Apri WhatsApp</a>
          </div>
        </div>
      )}
    </div>
  );
}
